import { render } from "./B2bFilterButtonDocumentacion.vue?vue&type=template&id=0ca4e8c8&scoped=true&lang=pug"
import script from "./B2bFilterButtonDocumentacion.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonDocumentacion.vue?vue&type=script&lang=js"

import "./B2bFilterButtonDocumentacion.vue?vue&type=style&index=0&id=0ca4e8c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4e8c8"]])

export default __exports__